import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import objectHelpers from '../../utilities/objectHelpers';

const WAIT_INTERVAL = 500;

const validPhone = RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/i);

const PhoneNumber = React.memo((props) => {
    const [value, setValue] = useState('');
    const [timer, setTimer] = useState(null);

    const touched = objectHelpers.get(props.formHandler.touched, props.name);
    const errors = objectHelpers.get(props.formHandler.errors, props.name);
    const formikValue = objectHelpers.get(props.formHandler.values, props.name);

    useEffect(() => {
        //if (value.test(formikValue)) {
            const val = formikValue?.replace(validPhone, "($1) $2-$3");
        //}

        setValue(val);
    }, [formikValue]);

    const handleChange = (e) => {
        const locValue = e.target.value;
        props.formHandler.handleChange({ target: { value: locValue, name: props.name } });
        //clearTimeout(timer);
        //setTimer(null);
        //const locValue = e.target.value;
        //setValue(locValue)
        //let localTimer = setTimeout(() => triggerChange(locValue), WAIT_INTERVAL);
        //setTimer(localTimer);
    };

    const handleBlur = (e) => {
        //triggerChange(value);
        props.formHandler.handleBlur(e)
    }

    const triggerChange = (updateValue) => {
        props.formHandler.handleChange({ target: { value: updateValue, name: props.name } });
        clearTimeout(timer);
        setTimer(null);
    };

    return (
        <>
            <Form.Label disabled={props.disabled} className={props.label ?? "d-none"}>{props.label}</Form.Label>
            <Form.Control
                disabled={props.disabled}
                type={props.type ? props.type : "text"}
                className={props.className}
                placeholder={props.placeholder}
                value={value}
                onChange={(e) => handleChange(e)}
                onBlur={(e) => handleBlur(e)}
                name={props.name}
                isInvalid={touched && errors}
            />
            <Form.Control.Feedback disabled={props.disabled} type="invalid">{errors}</Form.Control.Feedback>
        </>
    );
})

export default PhoneNumber;